// src/utils/platformCheckoutTemplates.js
export const PLATFORM_CHECKOUT_PARAMS = {
    BuyGoods: [
      "orderid={ORDERID}",
      "amount={COMMISSION_AMOUNT}",
      "cy=USD",
      "status=approved",
      "product={PRODUCT_CODENAME}",
      "conv_type={CONV_TYPE}",
      "click_id={SUBID}",
      "trackid={SUBID2}",
      "subid3={SUBID3}",
      "subid4={SUBID4}",
      "subid5={SUBID5}",
    ],
    Cartpanda: [
      "orderid={order_id}",
      "conv_type={transaction_type}",
      "order_type={order_type}",
      "product={product_name}",
      "trackid={cid}",
      "click_id={gclid}",
      "subid1={sid1}",
      "subid2={sid2}",
      "subid3={sid3}",
      "subid4={sid4}",
    ],
    ClickBank: [
      "click_id={extclid}",
      "orderid={event_id}",
      "amount={affiliate_earnings}",
      "cy={currency}",
      "product={vendor}",
      "conv_type={event_type}",
      "trackid={tid}",
      "timesale={event_time}",
      "language={language}",
      "subid1={aff_sub1}",
      "subid2={aff_sub2}",
      "subid3={aff_sub3}",
      "subid4={aff_sub4}",
      "subid5={aff_sub5}",
      "accountname={affiliate}",
      "traffics={traffic_source}",
      "traffict={traffic_type}",
      "country={country}",
      "state={state}",
      "statec={state_code}",
      "postalcode={postal_code}",
      "devicet={device_type}",
      "deviceb={device_brand}",
      "browser={browser}",
      "browserl={browser_lang}",
    ],
    MaxWeb: [
      "orderid={ORDERID}",
      "amount={COMMISSION_AMOUNT}",
      "cy=USD",
      "product={PRODUCT_CODENAME}",
      "conv_type={CONVERSION_TYPE}",
      "subid1={SUBID1}",
      "subid2={SUBID2}",
      "subid3={SUBID3}",
      "subid4={SUBID4}",
      "subid5={SUBID5}",
    ],
  };
  